import { TypedUseSelectorHook, useSelector } from "react-redux";
import { TypedRootState } from "../store/types";

export const useAppSelector: TypedUseSelectorHook<TypedRootState> = useSelector;
